import tw from 'twin.macro';
import * as React from 'react';
import { ReactNode } from 'react';

const ContentWidth = ({ children }: { children: ReactNode }) => (
  <div css={tw`max-w-6xl mx-auto w-11/12`}>{children}</div>
);

export default ContentWidth;
